import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContactCardLogos } from "@/components/contacting/ContactCard/addons";
import { StandaloneBadges } from "@/components/contacting/ProviderSection/StandaloneBadges/StandaloneBadges";
import { useContactCardSection, useContactSections, useProviderSection, } from "@/contexts/contact";
import { useFarbwelt } from "@/hooks";
import { useScrollTo } from "@/hooks/useScrollTo";
import { useI18n } from "@/shared/hooks";
import { PublisherTypeEnum } from "@/types";
import { InteractionEnum } from "@/types/customerActions";
import { Box } from "@gemini/core";
import { CellContent } from "@gemini/ui";
export const contactCardMobileTestId = "cdp-contact-card-mobile";
export const ContactCardMobile = () => {
    var _a;
    const contactCardSection = useContactCardSection();
    // @ts-ignore
    const isPrivateOwner = useContactSections().contactCard.isPrivateOwner;
    const { isFarbweltActive, bgColor, showFarbweltBanner } = useFarbwelt();
    const scrollToProvider = useScrollTo(InteractionEnum.SCROLL_TO_PROPERTY_PROVIDER);
    const { t } = useI18n();
    const { intermediaryCard, publisherType } = (_a = useProviderSection()) !== null && _a !== void 0 ? _a : {};
    // for Agents, display PublisherType / AgencyName in Agency Card
    const getAgencyDescription = () => {
        if (intermediaryCard === null || intermediaryCard === void 0 ? void 0 : intermediaryCard.display) {
            return publisherType && PublisherTypeEnum[publisherType]
                ? t(PublisherTypeEnum[publisherType])
                : intermediaryCard.subtitle;
        }
        return "";
    };
    return (_jsxs(Box, { position: "relative", width: "100%", display: "flex", flexDirection: "column", justifyContent: "flex-start", padding: "spacing.none", children: [isFarbweltActive && showFarbweltBanner && (_jsx(Box, { borderTopLeftRadius: "radius.8", borderTopRightRadius: "radius.8", height: "sizing.16", unsafe_style: {
                    backgroundColor: isFarbweltActive ? bgColor : "transparent",
                }, testId: contactCardMobileTestId })), _jsx(Box, { marginTop: isFarbweltActive && showFarbweltBanner ? "spacing.8" : "spacing.none", children: _jsx(CellContent, { title: contactCardSection === null || contactCardSection === void 0 ? void 0 : contactCardSection.title, 
                    // @ts-ignore
                    description: isPrivateOwner
                        ? contactCardSection === null || contactCardSection === void 0 ? void 0 : contactCardSection.subtitle
                        : getAgencyDescription(), padding: undefined, onPress: scrollToProvider, placeholderStart: () => (_jsx(ContactCardLogos, { rootTestId: contactCardMobileTestId, width: "initial", fixedSize: "48", isMobileView: true })) }) }), _jsx(Box, { display: {
                    "breakpoint.base": "block",
                    "breakpoint.sm": "none",
                }, justifyContent: "flex-start", paddingHorizontal: "spacing.8", paddingTop: "spacing.4", children: _jsx(StandaloneBadges, { rootTestId: `${contactCardMobileTestId}.StandaloneBadges`, marginTop: "spacing.none", marginBottom: "spacing.none" }) })] }));
};
